export { default, type HistoryLogRenderedBy } from './ModalHistoryLog';
